import {StatusPill} from "@/components/statusPill/StatusPill.tsx";
import {PillStatus} from "@/components/statusPill/StatusPill.types.ts";
import {StatusPageList} from "@/lib/types/statuspages.ts";

export interface StatusPageStatusCellProps {
  statusPage: StatusPageList;
}

export const StatusPageStatusCell = ({statusPage}: StatusPageStatusCellProps) => {
  return (
    <div className="text-nowrap gap-1 d-flex align-items-center">
      <StatusPill
        type={"incident"}
        status={statusPage.active_incidents_count ? PillStatus.ACTIVE_INCIDENTS : PillStatus.OPERATIONAL}
        variant={"textAndIcon"}
        className="text-nowrap"
      />
      {statusPage.active_maintenance_count! > 0 && (
        <StatusPill type={"checks"} status={PillStatus.MAINTENANCE} variant={"icon"} />
      )}
      {statusPage.scheduled_maintenance_count! > 0 && (
        <StatusPill type={"checks"} status={PillStatus.SCHEDULED_MAINTENANCE} variant={"icon"} />
      )}
    </div>
  );
};
